export default __webpack_public_path__ + "static/media/19_photo.b0d81462.jpg";